export default __webpack_public_path__ + "static/bg3-12af52e42903d9d623cfe7424d8a8d62.jpg";